import React from 'react';
import { connect } from 'react-redux';
import { SIcon } from '@avalara/skylab-sdk/react';

import Logger, { LOG_LEVELS } from '../../utils/logger';

const log = new Logger('APPLICATION_MESSAGES_ICONS', LOG_LEVELS.DEBUG);

export class ApplicationMessagesIcons extends React.Component {

    render() {
        log.debug('render(): ', this.props);
        return (
            <span className="display-contents">
                {this.props.messageStatus === "info" ? <SIcon className="medium absolute" role="img" aria-label="info-circle-filled" name="info-circle-filled" /> : <></>}
                {this.props.messageStatus === "success" ? <SIcon className="medium absolute" role="img" aria-label="check-circle-filled" name="check-circle-filled" /> : <></>}
                {this.props.messageStatus === "warning" ? <SIcon className="medium absolute" role="img" aria-label="alert-triangle-filled" name="alert-triangle-filled" /> : <></>}
                {this.props.messageStatus === "error" ? <SIcon className="medium absolute" role="img" aria-label="alert-circle-filled" name="alert-circle-filled" /> : <></>}
            </span>
        )
    }
}

function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}

// Wrap the component to inject state into it
export default connect(mapStateToProps)(ApplicationMessagesIcons);